<template>
  <div
    :class="`
        inline-block
        py-4
        w-fit
        relative
        drop-shadow`"
  >
    <NuxtLink
      :to="url"
      external
      :class="[
        `
            px-16
            py-11
            rounded-full
            leading-24
            text-20
            cursor-pointer
            border-border-primary
            border-md
            border-solid
            shadow-button
            no-underline
            focus-rounded
            ${
              $router.currentRoute.value.path === url
                ? 'bg-surface-action-1 text-text-on-highlight hover:text-text-on-highlight'
                : 'bg-surface-action-2 text-text-on-action hover:bg-surface-action-hover hover:text-text-on-action'
            }
        `,
      ]"
    >
      {{ title }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  url: string;
  title: string;
}>();
</script>

<style scoped></style>
